import { combineReducers } from "@reduxjs/toolkit";
import activityLogSlice from "./features/activity_logs/index.jsx";
import authSlice from "./features/auth/index.jsx";
import locationSlice from "./features/location/index.jsx";
import countrySlice from "./features/country/index.jsx";
import dashboardSlice from "./features/dashboard/index.jsx";
import tweetsSlice from "./features/tweets/index.jsx";

import userSlice from "./features/user/index.jsx";

const rootReducer = combineReducers({
  auth: authSlice,
  logs: activityLogSlice,
  location: locationSlice,
  countries: countrySlice,
  home: dashboardSlice,
  user: userSlice,
  tweets: tweetsSlice,
});

export default rootReducer;
